/**
 * Newsletter Popup and Cookie Consent Functionality
 * Handles localStorage-based popup display logic with optimized timing
 * Best Practice: Cookie consent shows first, newsletter shows after user engagement
 */

(function () {
  "use strict";

  // Timing constants following UX best practices
  const COOKIE_DELAY = 800; // 800ms - Quick but not jarring (legally required)
  const NEWSLETTER_TIME_DELAY = 8000; // 8 seconds - Optimal engagement window
  const NEWSLETTER_SCROLL_THRESHOLD = 0.4; // 40% scroll trigger

  // Track if cookie consent was shown
  let cookieConsentShown = false;

  // Track if popup has been triggered in this session
  let popupTriggered = false;

  // Newsletter Popup Functions
  function initNewsletterPopup() {
    try {
      const dismissed = localStorage.getItem("newsletter:popupDismissed");
      const subscribed = localStorage.getItem("newsletter:subscribed");
      const sessionDismissed = sessionStorage.getItem("newsletter:sessionDismissed");

      // Don't show if permanently dismissed, subscribed, or dismissed this session
      if (dismissed || subscribed || sessionDismissed) {
        return;
      }

      const popup = document.getElementById("newsletter-popup");
      if (!popup) {
        return;
      }

      // Function to show the popup
      function showPopup() {
        if (!popupTriggered) {
          popupTriggered = true;
          popup.style.display = "block";
        }
      }

      // Timer-based trigger (8 seconds)
      setTimeout(function () {
        showPopup();
      }, NEWSLETTER_TIME_DELAY);

      // Scroll-based trigger (40% of page)
      function checkScroll() {
        if (popupTriggered) {
          return; // Already shown
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight =
          document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = scrollTop / docHeight;

        if (scrollPercent >= NEWSLETTER_SCROLL_THRESHOLD) {
          showPopup();
          window.removeEventListener("scroll", checkScroll);
        }
      }

      window.addEventListener("scroll", checkScroll, { passive: true });
    } catch (e) {
      console.error("Error initializing newsletter popup:", e);
    }
  }

  window.closeNewsletterPopup = function () {
    try {
      // Use sessionStorage for soft dismissal - won't show again this session
      sessionStorage.setItem("newsletter:sessionDismissed", "1");
      const popup = document.getElementById("newsletter-popup");
      if (popup) {
        popup.style.display = "none";
      }
    } catch (e) {
      console.error("Error closing newsletter popup:", e);
    }
  };

  // Newsletter form submission is now handled by newsletter-popup.js
  // This function is kept for backwards compatibility but does nothing
  function handleNewsletterSubmit() {
    // Newsletter popup behavior is now managed by newsletter-popup.js
    // which handles showing the discount code after submission
  }

  // Cookie Consent Functions
  function initCookieConsent() {
    try {
      const choice = localStorage.getItem("cookies:consent");

      if (!choice) {
        const consent = document.getElementById("cookie-consent");
        if (consent) {
          // Mark that cookie consent will be shown
          cookieConsentShown = true;

          setTimeout(function () {
            consent.style.display = "block";
          }, COOKIE_DELAY);
        }
      }
    } catch (e) {
      console.error("Error initializing cookie consent:", e);
    }
  }

  window.acceptCookies = function () {
    try {
      localStorage.setItem("cookies:consent", "accepted");
      const consent = document.getElementById("cookie-consent");
      if (consent) {
        consent.style.display = "none";
      }

      // If Shopify Customer Privacy API is loaded, set consent
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            marketing: true,
            analytics: true,
            preferences: true,
          },
          function () {
            console.log("Cookie consent submitted to Shopify");
          },
        );
      }
    } catch (e) {
      console.error("Error accepting cookies:", e);
    }
  };

  window.declineCookies = function () {
    try {
      localStorage.setItem("cookies:consent", "declined");
      const consent = document.getElementById("cookie-consent");
      if (consent) {
        consent.style.display = "none";
      }

      // If Shopify Customer Privacy API is loaded, set consent
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            marketing: false,
            analytics: false,
            preferences: false,
          },
          function () {
            console.log("Cookie decline submitted to Shopify");
          },
        );
      }
    } catch (e) {
      console.error("Error declining cookies:", e);
    }
  };

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initNewsletterPopup();
      initCookieConsent();
      handleNewsletterSubmit();
    });
  } else {
    initNewsletterPopup();
    initCookieConsent();
    handleNewsletterSubmit();
  }

  // Close popups on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      const newsletterPopup = document.getElementById("newsletter-popup");
      const cookieConsent = document.getElementById("cookie-consent");

      if (newsletterPopup && newsletterPopup.style.display !== "none") {
        window.closeNewsletterPopup();
      }

      if (cookieConsent && cookieConsent.style.display !== "none") {
        window.declineCookies();
      }
    }
  });
})();
